export default __webpack_public_path__ + "static/media/fpa50000.b48148cf.png";